import { CLOSE_MENU, OPEN_MENU } from "core-web/state/models/Header/constants";

import store from "core-web/state/store";

export const toggleMenu = (toggleState) => (dispatch) => {
    if (toggleState) {
        dispatch({
            type: OPEN_MENU,
        });
    } else {
        dispatch({
            type: CLOSE_MENU,
        });
    }
};

export default (toggleState) => store.dispatch(toggleMenu(toggleState));
